import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { ArrowUpDown } from 'lucide-react'
import { ToggleSwitch } from '../ToggleSwitch'
import { formatMoney } from '../../../utils/format-money'

// Aircon booking step, under the service address. A passive line, not a
// question: the ceiling is asked properly in the Confirm Details sheet after
// payment (see utils/high-ceiling.js), so most customers book without touching
// this. Choosing High here puts the tall-ladder surcharge in the booking price
// instead of on the final bill.
export const CeilingLine = ({ isHighCeiling, setIsHighCeiling, market, extra, currencyCode, variants }) => {
    const [ isOpen, setIsOpen ] = useState(false)
    const ladderFee = formatMoney(market.highCeilingSurcharge, market.countryCd, 0)

    return (
        <motion.div
            variants={variants}
            className="bg-gray-50 rounded-xl p-3"
        >
            <div className="flex items-start gap-2">
                <div className="shrink-0 w-8 h-8 rounded-lg bg-orange-100 flex items-center justify-center text-orange-600">
                    <ArrowUpDown className="w-4 h-4" />
                </div>
                <div className="flex-1 min-w-0">
                    <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-0.5">
                        Ceiling Height
                    </div>
                    <div className="text-sm text-gray-700">
                        {isHighCeiling
                            ? `High, tall ladder (+${currencyCode} ${extra})`
                            : `Normal · ${market.normalCeilingHomes}`}
                    </div>
                </div>
                {!isOpen && (
                    <button
                        type="button"
                        onClick={() => setIsOpen(true)}
                        className="shrink-0 self-center px-3 py-1.5 text-xs font-semibold text-orange-600 bg-white border border-orange-200 rounded-lg hover:bg-orange-50"
                    >
                        Change
                    </button>
                )}
            </div>
            {isOpen && (
                <div className="mt-3 space-y-2">
                    <ToggleSwitch
                        checked={isHighCeiling}
                        onChange={() => setIsHighCeiling(!isHighCeiling)}
                        leftLabel="Normal"
                        rightLabel={`High (+${ladderFee})`}
                        withContainer
                    />
                    <p className="text-xs text-gray-500">
                        High ceilings (landed properties, duplex houses) need a tall ladder: {ladderFee} per visit.
                    </p>
                </div>
            )}
        </motion.div>
    )
}
